import React from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import {Link} from "react-router-dom";
import './Footer.css';

function Footer() {
  return (
    <div id="footer"> 
        <div className='content'>
        <Nav.Link as={Link} to="/" href="#Home" >Home</Nav.Link> |     <Nav.Link as={Link} to="Bio" href="#Bio">Bio</Nav.Link> | <Nav.Link as={Link} to="Scripts" href="#Scripts">Scripts</Nav.Link> | <Nav.Link as={Link} to="Screenwriting" href="#Screenwriting">Screenwriting</Nav.Link> | <Nav.Link as={Link} to="Consulting" href="#Consulting">Script Consulting</Nav.Link> |  <Nav.Link as={Link} to="Music" href="#Music">Music for Film</Nav.Link> | <Nav.Link as={Link} to="Recommendations" href="#Recommendations">Recommendations</Nav.Link><br />
        <Nav.Link as={Link} to="Newsletter" href="#Newsletter">Christian Screenwriters' Newsletter</Nav.Link> | <a href="http://www.ambassadorcommunications.biz/" target="_blank" rel="noopener noreferrer">Ambassador Communications</a> | <Nav.Link as={Link} to="Store" href="#Store">Store</Nav.Link> | <Nav.Link as={Link} to="Contact" href="#Contact">Contact</Nav.Link><br />
    <span className="designCredit">Site designed and maintained by <a href="http://www.davidsilberman.com" target="_blank" rel="noopener noreferrer">David Silberman</a></span>
       </div>
    </div>
  )
}
export default Footer;
